import { CaptchaService } from './services/captcha.service';
import { SecurityService } from './services/security/security.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderModule } from './components/header/header.module';
import { StorageModule } from './utils/storage.module';
import { CmsService } from './services/cms/cms.service';
import { StepPageResolver } from './resolvers/step-page.resolver';
import { JourneyService } from './services/journey.service';
import { PageModule } from './components/page/page.module';
import { TrackingModule } from './directives/tracking.module';
import { NgxMaskModule } from 'ngx-mask';
import { ButtonModule } from './components/forms/button/button.module';
import { LinkButtonModule } from './components/forms/link-button/link-button.module';
import { CustomPipesModule } from './pipes/pipes.module';
import { BoxInfoModule } from './components/containers/box-info/box-info.module';
import { NetworkService } from './services/network.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppInterceptorService } from './interceptors/app.interceptor';
import { QrCodeScannerModule } from './components/qr-code-scanner/qr-code-scanner.module';
import { CardSmallModule } from './components/card-small/card-small.module';
import { DssMaskModule } from '@dss/components/mask';

@NgModule({
  declarations: [ ],
  imports: [
    CommonModule,
    HeaderModule,
    StorageModule,
    PageModule,
    ButtonModule,
    LinkButtonModule,
    TrackingModule,
    CustomPipesModule,
    BoxInfoModule,
    CardSmallModule,
    DssMaskModule
  ],
  exports:[
    NgxMaskModule,
    HeaderModule,
    StorageModule,
    PageModule,
    ButtonModule,
    LinkButtonModule,
    TrackingModule,
    CustomPipesModule,
    BoxInfoModule,
    CardSmallModule,
    DssMaskModule
  ],
  providers: [
    CmsService,
    StepPageResolver,
    JourneyService,
    NetworkService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppInterceptorService,
      multi: true,
    },
    CaptchaService,
    SecurityService
  ]
})
export class SharedModule { }
